import React, { useState, useEffect, useRef } from 'react';

import TextInput from '../TextInput';

export default function EditableText({
  name,
  placeholder,
  label,
  value,
  tabindex,
  index,
  prevGroupsSize,
  isVisible,
  onChange,
  handleBlur,
  error,
  touched,
}) {
  const [isEditMode, setIsEditMode] = useState(false);

  const inputRef = useRef();

  // Focus on input on edit mode
  useEffect(() => {
    if (isEditMode) {
      inputRef.current.focus();
    }
  }, [isEditMode]);

  return (
    <div className="flex items-end justify-start">
      {isEditMode ? (
        <div className="flex items-end gap-2">
          <TextInput
            tabindex={tabindex || index + 1 + prevGroupsSize}
            key={name}
            name={name}
            label={label}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            onBlur={handleBlur}
            error={error}
            touched={touched}
            isVisible={isVisible}
            readOnly={!isEditMode}
            disabled={!isEditMode}
            reference={inputRef}
          />
          <div className="pb-1">
            <button
              onClick={() => {
                setTimeout(() => {
                  setIsEditMode(false);
                }, 200);
              }}
              type="submit"
              className="p-1.5 shrink-0 rounded bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 shadow-sm"
            >
              <svg
                className="w-4 h-4 fill-current shrink-0 transform scale-150 text-slate-500"
                viewBox="0 0 16 16"
              >
                <path d="m2.457 8.516.969-.99 2.516 2.481 5.324-5.304.985.989-6.309 6.284z" />
              </svg>
            </button>
          </div>
        </div>
      ) : (
        <div>
          <div className="flex text-sm font-medium mb-1 items-center gap-2">
            {label}
          </div>
          <div className="flex items-end">
            {value && (
              <div className="form-input border-none shadow-none w-fit h-[37.13px]">
                {value}
              </div>
            )}
            <div className="pb-1">
              <button
                onClick={() => setIsEditMode(true)}
                type="button"
                className="p-1.5 shrink-0 rounded bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 shadow-sm"
              >
                <svg
                  className="w-4 h-4 fill-current text-slate-500"
                  viewBox="0 0 16 16"
                >
                  <path d="M11.7.3c-.4-.4-1-.4-1.4 0l-10 10c-.2.2-.3.4-.3.7v4c0 .6.4 1 1 1h4c.3 0 .5-.1.7-.3l10-10c.4-.4.4-1 0-1.4l-4-4zM4.6 14H2v-2.6l6-6L10.6 8l-6 6zM12 6.6L9.4 4 11 2.4 13.6 5 12 6.6z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
